export default __webpack_public_path__ + "static/media/cpLaundryPassPinkZhtw.062cb51b.jpg";